import React from 'react';
import { Collapse } from 'reactstrap';
import styles from './index.module.scss';

import { If } from 'utils';
import { PageErrorUi, UiKit } from 'components';

export default function FeeConfig({
  title = '',
  subtitle = '',
  isError = false,
  isActive = false,
  isDisabled = false,
  isProcessing = false,
  onToggle = () => {},
  onReload = () => {},
  children = null
}) {
  return (
    <UiKit.Card>
      <UiKit.Card.Body>
        <PageErrorUi
          hideImage
          isError={isError}
          onReload={onReload}
          wrapperClassName="py-0"
          msg="Unable to load the fee info."
        >
          <UiKit.Flex gap={16} align="flex-start">
            <UiKit.Flex align="center" className={styles.cell}>
              <UiKit.Toggle
                isActive={isActive}
                disabled={isDisabled || isProcessing}
                onChange={onToggle}
              />
            </UiKit.Flex>
            <UiKit.Flex direction="column" className="flex-1">
              <UiKit.Flex align="center" justify="space-between" gap={8}>
                <UiKit.Flex direction="column">
                  <UiKit.Text className={styles.title} weight="bold">
                    {title}
                  </UiKit.Text>
                  <UiKit.Text size="sm">{subtitle}</UiKit.Text>
                </UiKit.Flex>
                <If test={isProcessing}>
                  <UiKit.Flex align="center" justify="space-between" gap={8}>
                    <UiKit.Text variant={600}>Saving</UiKit.Text>
                    <UiKit.Spinner size="sm" />
                  </UiKit.Flex>
                </If>
              </UiKit.Flex>
              <Collapse isOpen={isActive}>
                <UiKit.Separator className="my-3" />
                {children}
              </Collapse>
            </UiKit.Flex>
          </UiKit.Flex>
        </PageErrorUi>
      </UiKit.Card.Body>
    </UiKit.Card>
  );
}
